import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayAdjustmentSubmittedPayload {
  shiftId: string;
}

/**
 * Fires when an office clicks the CTA that advances past the adjustment step —
 * either "Confirm" (nothing to adjust) or "Submit & Continue".
 * Event: dental_portal:end_of_day:adjustment_submitted
 */
export function fireEndOfDayAdjustmentSubmitted(
  payload: IEndOfDayAdjustmentSubmittedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:adjustment_submitted', {
    shift_id: payload.shiftId,
  });
}
